import { Store } from '~/types/store'

const serializeObject = (obj: any) => {
  let objStr = JSON.stringify(obj)
  objStr = objStr.replace(/\{/g, encodeURIComponent('{'))
  objStr = objStr.replace(/}/g, encodeURIComponent('}'))
  objStr = objStr.replace(/:/g, encodeURIComponent(':'))

  return objStr
}

export const setURLQuery = (opts: any) => {
  const { filters, sort, route, router, path, withCleanUp = false } = opts
  const query = { ...route.query }

  const proc = {
    filters: (val: Store.Filter.FilterSet) => serializeObject(val),
    sort: (val: any) => val.sortField + ',' + val.sortDir
  }

  // @ts-ignore
  const updateQuery = (propName, value, query) => {
    if (value instanceof Object) {
      if (Object.keys(value).length) {
        // @ts-ignore
        query[propName] = proc[propName](value)
      } else {
        delete query[propName]
      }
    } else if (!value && withCleanUp) {
      delete query[propName]
    }
  }

  updateQuery('filters', filters, query)
  updateQuery('sort', sort, query)

  let routePath = path
  if (!routePath) {
    routePath = route.params.subTabName
      ? `/scholarships/${route.params.tabName}/${route.params.subTabName}`
      : `/scholarships/${route.params.tabName}`
  }

  const pushResult = router.push({ path: routePath, query })
  if (pushResult && pushResult.catch) {
    pushResult.catch((err: any) => {
      if (err?.name !== 'NavigationDuplicated') {
        console.error('setURLQuery navigation error:', err)
      }
    })
  }
}

// @ts-ignore
export const removeURLQuery = (tabName, router) => {
  router.push({ path: `/scholarships/${tabName}` })
}

// @ts-ignore
export const updateStore = ({ tabName, query, $accessor }) => {
  if (!tabName) { return }

  if (!Object.keys(query).length) {
    $accessor.sorting.removeSorting({ tabName })
    return
  }

  $accessor.filters.resetAllFilters({ tabName })
  if (query.filters) {
    const filters = JSON.parse(decodeURIComponent(query.filters as string))
    for (const filterName of Object.keys(filters)) {
      $accessor.filters.addFilter({ tabName, filterName, value: filters[filterName] })
    }
  }

  if (query.sort) {
    const [sortField, sortDir] = query.sort.split(',')
    $accessor.sorting.addSorting({ tabName, sortField, sortDir })
  } else {
    $accessor.sorting.removeSorting({ tabName })
  }
}
